<style>
    .error {
        color: #ff4444;
    }
</style>

<fadv-box [formGroup]="formGroup">
    <fadv-grid>
        <fadv-grid-row>
            <fadv-grid-col alignment="left">
                <fadv-typography type="label-medium" weight="500">Previous Addresses</fadv-typography>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col>
                <fadv-typography type="label-small">Please enter the postal code of any residences from the past 7 years.</fadv-typography>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col col="12" alignment="left">
                <fadv-input (blur)="showValidation('previousAddress')" maxLength="5" minLength="5" formControlName="previousAddress" type="text" label="Postal Code"></fadv-input>
                <span class="error" *ngIf="this.previousAddressInvalid == true || postalCodeExists">
                    <small *ngIf="formGroup.get('previousAddress').hasError('required')">Postal Code is Required</small>
                    <small *ngIf="formGroup.get('previousAddress').hasError('minlength') || formGroup.get('previousAddress').hasError('pattern')">Postal Code must be 5 numbers</small>
                    <small *ngIf="!previousAddressInvalid && postalCodeExists">You've already added this postal code</small>
                  </span>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-box mt="small">
            <fadv-grid-row>
                <fadv-grid-col [col]="{ xxl: 2, xl: 3, lg: 3, md: 4, sm: 12, xs: 12 }">
                    <fadv-box [mb]="{ sm: 'medium', xs: 'medium' }">
                        <fadv-button pill="true" style="margin-right:20px;" [disabled]="formGroup.value.previousAddress.length < 5" [loading]="loading"
                         [active]="loading" size="medium" variant="primary" (click)="addPreviousAddress()" type="button" name="add-postal-code-button">Add Postal Code</fadv-button>
                    </fadv-box>
                </fadv-grid-col>
                <fadv-grid-col [col]="{ xxl: 10, xl: 9, lg: 9, md: 8, sm: 12, xs: 12 }">
                    <fadv-box [mb]="{ sm: 'medium', xs: 'medium' }">
                        <fadv-tag style="margin-right:5px;margin-bottom:15px;top:3px;" *ngFor="let address of previousAddresses;" removable="true" size="large" pill="true" (removed)="removePreviousAddress(address)" variant="success">{{ address }}</fadv-tag>
                    </fadv-box>
                </fadv-grid-col>
            </fadv-grid-row>
        </fadv-box>
    </fadv-grid>
</fadv-box>